<template>
    <div>
        <div style="margin: 16px">
            <CompaniesTableHeader :showButton="hasSelected" :hasInputSearch="false"
                :selectedRowKeys="this.selectedRowKeys" @toggle-modal="toggleModal"
                urlCreate='./companies-emisoras/add' />
        </div>
        <div class="bg-white overflow-x-auto rounded-xl border border-gray-300 mx-4 mt-4 search-complaints">
            <a-table :columns="columns" rowKey="id" :data-source="dataSource" :pagination="false"
                :scroll="{ x: '1220px' }" :row-selection="{
                    selectedRowKeys: selectedRowKeys,
                    onChange: onSelectChange,
                }">
                <div slot="name" class="title-size font-bold text-gray-500 text-center">
                    Nombre
                </div>
                <div slot="nit" class="title-size font-bold text-gray-500 text-center">
                    NIT
                </div>
                <div slot="companyemisores_type_name" class="title-size font-bold text-gray-500 text-center">
                    Tipo de entidad
                </div>
                <div slot="code" class="title-size font-bold text-gray-500 text-center">
                    Código
                </div>
                <div slot="companyemisores_control_name" class="title-size font-bold text-gray-500 text-center">
                    Control / Vigilado
                </div>
                <div slot="creation_date" class="title-size font-bold text-gray-500">
                    Fecha de creación
                </div>
                <div slot="actions" slot-scope="text, record"
                    class="text-sm font-medium text-right whitespace-nowrap flex">
                    <a-switch v-model="record.is_active" @change="onSwitchChange($event, record)" />
                    <router-link :to="`./edit/${record.id}`"
                        class="ml-3 h-6 w-6 p-1 text-blue-600 dark:text-blue-500 shadow rounded" append>
                        <img class="h-full w-full" src="@/assets/icons/pen.svg" alt="" />
                    </router-link>
                </div>
            </a-table>
        </div>
        <ModalConfirmation :visible="showModal" :companies="selectedRowKeys" @toggle-modal="toggleModal" />
        <!-- :data="data" -->
    </div>
</template>

<script>
import companiesEmisoresServices from "@/feature/dashboard/companies-emisores/data/services/companies_emisores_services_impl";
import CompaniesTableHeader from "@/components/Dashboard/Companies/CompaniesTableHeader";
import ModalConfirmation from "./ModalConfirmation.vue";

const columns = [
    {
        slots: { title: "name" },
        dataIndex: "name",
        key: "name",
        width: 180,
    },
    {
        slots: { title: "nit" },
        dataIndex: "nit",
        key: "nit",
        width: 180,
    },
    {
        slots: { title: "companyemisores_type_name" },
        dataIndex: "companyemisores_type_name",
        key: "companyemisores_type_name",
        width: 150,
    },
    {
        slots: { title: "code" },
        dataIndex: "code",
        key: "code",
        width: 190,
    },
    {
        slots: { title: "companyemisores_control_name" },
        dataIndex: "companyemisores_control_name",
        key: "companyemisores_control_name",
        width: 120,
    },
    {
        title: 'Acciones',
        slots: { title: "actions" },
        dataIndex: "actions",
        key: "actions",
        scopedSlots: { customRender: "actions" },
        width: 100,
    },
];

export default {
    components: {
        CompaniesTableHeader,
        ModalConfirmation
    },
    props: ["dataSource"],
    data() {
        return {
            columns,
            selectedRowKeys: [],
            showModal: false,
        };
    },
    methods: {
        async onSwitchChange(checked, record) {
            this.loading = true;
            this.showToast("Procesando cambio de estado...", "info");
            const { error, data } = await companiesEmisoresServices.ActiveInactiveCompanyEmisores(record.id, { is_active: checked });
            this.loading = false;
            if (error) this.showToast("Error inacitvando entidades.", "error");
            if (data) this.showToast("Actualización de estado éxitosa.", "success");
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },
        toggleModal(value) {
            this.showModal = value?.toggle;
            if (value?.reload) {
                // this.setFilterInData();
                this.$emit('reload-data');
            }
        },
        showToast(msg, result) {
            this.$notification[result]({
                message: "Resultado",
                description: msg,
                onClick: () => { },
            });
        },
    },
    computed: {
        hasSelected() {
            return this.selectedRowKeys.length > 0;
        },
    },
};
</script>
